import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  campaignDataForBaseKPI: null,
  status: 'idle',
  error: null,
};

const dataSlice = createSlice({
  name: 'campaignDataForBaseKPI',
  initialState,
  reducers: {
    setCampaignDataForBaseKPI: (state, action) => {
      state.campaignDataForBaseKPI = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setCampaignDataForBaseKPI, setError, setLoading } =
  dataSlice.actions;
export default dataSlice.reducer;
